import React from 'react';

const MenuIcon: React.FC = () => {
  return(
    <svg  style={{display: 'flex', cursor: 'pointer', alignItems: 'center'}} xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 11">
      <g id="Group_535" transform="translate(0 0.011)">
        <g id="Rectangle_720" transform="translate(0 9.989)" fill="#939393" stroke="#939393" strokeWidth="2">
          <rect width="16" height="2" rx="0.5" stroke="none"/>
          <rect x="0.5" y="0.5" width="15" fill="none"/>
        </g>
        <g id="Rectangle_721" transform="translate(0 4.989)" fill="#939393" stroke="#939393" strokeWidth="2">
          <rect width="16" height="2" rx="0.5" stroke="none"/>
          <rect x="0.5" y="0.5" width="15" fill="none"/>
        </g>
        <g id="Rectangle_722" transform="translate(0 -0.011)" fill="#939393" stroke="#939393" strokeWidth="2">
          <rect width="16" height="2" rx="0.5" stroke="none"/>
          <rect x="0.5" y="0.5" width="15" fill="none"/>
        </g>
      </g>
    </svg>
  )
}

export default MenuIcon;